import React from "react";
import "./Pagination.scss";
const Pagination = ({ currentPage, totalPages, onPageChange,Recorsperpage, Totalrecords }) => {
  const pageNumbers = [];

  const maxPagesToShow = 5;
  const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
  const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

  if (startPage > 1) {
    pageNumbers.push(1);
    if (startPage > 2) {
      pageNumbers.push("...");
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      pageNumbers.push("...");
    }
    pageNumbers.push(totalPages);
  }
  return (
    <div className="pagination">
    <div>
        Showing {currentPage * Recorsperpage - Recorsperpage + 1}  to {(currentPage * Recorsperpage) > Totalrecords ? Totalrecords : (currentPage * Recorsperpage)} of {Totalrecords} records
      </div>

      <div>
      <div
        onClick={() => { currentPage !== 1 && onPageChange(currentPage - 1) }}
        disabled={currentPage === 1}
        style={currentPage !== 1 ? {cursor:"pointer"} : { color: "#9E9E9E",cursor:"no-drop" }}
      >
        Previous
      </div>

      {pageNumbers.map((number, index) =>
        typeof number === "number" ? (
          <button
            key={index}
            onClick={() => onPageChange(number)}
            className={number === currentPage ? "active" : "inactive"}
          >
            {number}
          </button>
        ) : (
          <span key={index} className="dots">
            {number}
          </span>
        )
      )}

      <div
        onClick={() => { (currentPage !== totalPages && totalPages > 0) && onPageChange(currentPage + 1) }}
        disabled={currentPage === totalPages}
        style={(currentPage !== totalPages && totalPages > 0) ? {cursor:"pointer"} : { color: "#9E9E9E",cursor:"no-drop" }}
      >
        Next
      </div>
    </div>
    </div>
  );
};

export default Pagination;
